var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h3',{staticClass:"reg see-breakdown link",on:{"click":_setup.openPricingBreakdownDialog}},[_vm._v("See breakdown")])
}
var staticRenderFns = []

export { render, staticRenderFns }